<template>
	<div class="video-call-container" v-loading="loading" element-loading-text="拼命加载中"
		element-loading-spinner="el-icon-loading">
		<!-- 头部信息栏 -->
		<div class="header-bar">
			<div class="header-left">
				<el-badge :value="connectionStatusText" :type="connectionStatusType" class="status-badge">
					<span class="device-info">设备ID: {{ deviceId }}</span>
				</el-badge>
			</div>
			<div class="header-right">
				<span class="connection-time" v-if="callDuration">{{ formatDuration(callDuration) }}</span>
			</div>
		</div>

		<!-- 视频显示区域 -->
		<div class="video-wrapper">
			<div class="main-video-area">
				<video id="remoteVideo" ref="remoteVideo" class="remote-video" autoplay playsinline
					@loadedmetadata="onVideoLoaded" @error="onVideoError"></video>
				<div class="video-overlay" v-if="!isPlaying">
					<div class="overlay-content">
						<el-icon :size="48" class="el-icon-video-camera"></el-icon>
						<span>{{ isConnecting ? '正在建立连接...' : '等待视频流...' }}</span>
					</div>
				</div>
				<!-- <div class="video-controls-overlay">
					<span class="video-quality">视频质量: {{ videoQuality }}</span>
				</div> -->
			</div>

			<!-- 本地预览小窗口 -->
			<div class="local-preview" v-if="showLocalPreview && localStream">
				<video id="localVideo" ref="localVideo" class="local-video" autoplay playsinline muted></video>
				<span class="local-label">本地</span>
			</div>
		</div>

		<!-- 控制面板 -->
		<div class="control-panel">
			<!-- <div class="control-group">
				<el-button 
					:icon="isMuted ? 'el-icon-volume-off' : 'el-icon-volume-2'" 
					:type="isMuted ? 'warning' : 'primary'"
					:circle="true"
					:size="'large'"
					@click="toggleMute"
					:disabled="!isConnected"
					tooltip="切换静音"
				></el-button>
				<span class="control-label">{{ isMuted ? '已静音' : '麦克风' }}</span>
			</div> -->

			<!-- <div class="control-group">
				<el-button 
					:icon="isVideoOff ? 'el-icon-video-camera-off' : 'el-icon-video-camera'" 
					:type="isVideoOff ? 'warning' : 'primary'"
					:circle="true"
					:size="'large'"
					@click="toggleVideo"
					:disabled="!isConnected"
					tooltip="切换摄像头"
				></el-button>
				<span class="control-label">{{ isVideoOff ? '已关闭' : '摄像头' }}</span>
			</div> -->

			<!-- <div class="control-group">
				<el-button icon="el-icon-refresh" type="success" :circle="true" :size="'large'" @click="refreshStream"
					:disabled="loading" tooltip="刷新视频流"></el-button>
				<span class="control-label">刷新</span>
			</div> -->
			<!-- 
			<div class="control-group quality-control">
				<el-select 
					v-model="selectedQuality" 
					placeholder="视频质量"
					:disabled="!isConnected"
					@change="changeVideoQuality"
					class="quality-select"
				>
					<el-option label="高清 (HD)" value="high"></el-option>
					<el-option label="标清 (SD)" value="medium"></el-option>
					<el-option label="流畅" value="low"></el-option>
				</el-select>
				<span class="control-label">画质</span>
			</div> -->

			<!-- <div class="control-group">
				<el-button 
					icon="el-icon-full-screen" 
					type="info"
					:circle="true"
					:size="'large'"
					@click="toggleFullscreen"
					tooltip="全屏"
				></el-button>
				<span class="control-label">全屏</span>
			</div> -->

			<div class="control-group disconnect-group">
				<el-button icon="el-icon-phone" type="danger" :circle="true" :size="'large'" @click="handleDisconnect"
					tooltip="结束通话"></el-button>
				<span class="control-label">结束</span>
			</div>
		</div>

		<!-- 日志输出区域 -->
		<div class="log-panel" :class="{ expanded: showLog }">
			<div class="log-header" @click="showLog = !showLog">
				<span class="log-title">系统日志</span>
				<el-icon :class="showLog ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></el-icon>
			</div>
			<div class="log-content" v-if="showLog">
				<div v-for="(log, index) in logs" :key="index" :class="'log-item log-' + log.type">
					<span class="log-time">{{ log.time }}</span>
					<span class="log-message">{{ log.message }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* global SIP, ZLMRTCClient */
export default {
	name: 'VideoCall',
	data() {
		return {
			// 配置信息
			wss: 'wss://caps.runde.pro/wss',
			api: 'https://caps.runde.pro/api/',

			// 连接状态
			ws: null,
			userAgent: null,
			sipsession: null,
			player: null,
			player1: null,
			loading: false,
			isConnecting: false,
			isConnected: false,
			isPlaying: false,
			wsInitiativeClose: false,

			// 设备信息
			deviceId: null,
			sipId: null,
			userIds: null,
			sipHost: null,
			adminId: null,

			// 用户凭证
			token: null,

			// 状态控制
			isMuted: false,
			isVideoOff: false,
			showLocalPreview: false,
			showLog: false,
			isGroupCall: false,

			// 视频质量
			videoQuality: '高清',
			selectedQuality: 'high',

			// 定时器
			heartbeatTimer: null,
			reconnectTimer: null,
			rtmpTimer: null,
			callDurationTimer: null,
			callDuration: 0,

			// 媒体流
			localStream: null,
			remoteStream: null,

			// 日志记录
			logs: [],

			// 重试计数
			reconnectCount: 0,
			maxReconnectAttempts: 3
		}
	},
	created() {
		this.deviceId = this.getDeviceIdFromUrl()
		if (!this.deviceId) {
			this.showError('无法获取设备ID，请检查URL参数')
			return
		}
		this.addLog('info', `设备ID: ${this.deviceId}`)
	},
	mounted() {
		this.initWebSocket()
		// 连接超时检测
		setTimeout(() => {
			if (this.loading && !this.isConnected) {
				this.showError('网络连接失败，请确认设备已开启')
				this.loading = false
			} else if (this.isConnected) {
				this.showSuccess('连接成功！')
			}
		}, 10000)

		// 监听页面关闭
		window.addEventListener('beforeunload', this.handleBeforeUnload)
	},
	beforeDestroy() {
		this.cleanup()
		window.removeEventListener('beforeunload', this.handleBeforeUnload)
	},
	computed: {
		connectionStatusText() {
			if (this.loading) return '加载中'
			if (this.isConnecting) return '连接中'
			if (this.isConnected) return '已连接'
			return '未连接'
		},
		connectionStatusType() {
			if (this.loading) return 'warning'
			if (this.isConnecting) return 'info'
			if (this.isConnected) return 'success'
			return 'danger'
		}
	},
	methods: {
		// 获取URL中的设备ID
		getDeviceIdFromUrl() {
			const urlParams = new URLSearchParams(window.location.search)
			return urlParams.get('id') || window.location.href.split('id=')[1] || null
		},

		// 添加日志
		addLog(type, message) {
			const now = new Date()
			const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`
			this.logs.push({ time: timeStr, message, type })
			if (this.logs.length > 100) {
				this.logs.shift()
			}
		},

		// 显示成功消息
		showSuccess(message) {
			this.$message({ message, type: 'success', duration: 3000 })
		},

		// 显示错误消息
		showError(message) {
			this.$message({ message, type: 'error', duration: 5000 })
			this.addLog('error', message)
		},

		// 格式化通话时长
		formatDuration(seconds) {
			const hrs = Math.floor(seconds / 3600)
			const mins = Math.floor((seconds % 3600) / 60)
			const secs = seconds % 60
			if (hrs > 0) {
				return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
			}
			return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
		},

		// 初始化WebSocket连接
		initWebSocket() {
			if (this.ws) {
				this.ws.close()
			}

			this.addLog('info', '正在建立WebSocket连接...')
			this.isConnecting = true

			try {
				this.ws = new WebSocket(this.wss)

				this.ws.onopen = () => {
					this.addLog('success', 'WebSocket连接成功')
					this.wsInitiativeClose = false
					this.startHeartbeat()
					this.login()
				}

				this.ws.onmessage = (e) => {
					sessionStorage.setItem('UserInfo', e.data)
					this.handleMessage(e.data)
				}

				this.ws.onclose = (e) => {
					this.addLog('warning', `WebSocket断开: ${e.code} - ${e.reason}`)
					this.stopHeartbeat()
					this.stopCallDuration()

					if (!this.wsInitiativeClose) {
						this.handleReconnect()
					}

					this.cleanupMedia()
				}

				this.ws.onerror = (e) => {
					this.addLog('error', `WebSocket异常: ${e.type}`)
					this.showError('WebSocket连接异常')
				}
			} catch (error) {
				this.addLog('error', `WebSocket初始化失败: ${error.message}`)
				this.showError('无法建立WebSocket连接')
			}
		},

		// 心跳保持
		startHeartbeat() {
			this.stopHeartbeat()
			this.heartbeatTimer = setInterval(() => {
				if (this.ws && this.ws.readyState === WebSocket.OPEN) {
					this.ws.send('1')
				}
			}, 15000)
		},

		stopHeartbeat() {
			if (this.heartbeatTimer) {
				clearInterval(this.heartbeatTimer)
				this.heartbeatTimer = null
			}
		},

		// 登录
		login() {
			this.addLog('info', '正在登录系统...')
			const user_name = '苏州麦科斯'
			const pwd = 'Max#0824'

			this.getToken(user_name, pwd).then((token) => {
				if (!token) {
					this.showError('获取Token失败')
					return
				}

				this.token = token
				const login_json = {
					act: 'ma_login',
					user_name,
					pwd,
					access_token: token
				}
				this.ws.send(JSON.stringify(login_json))
			}).catch(() => {
				this.showError('登录失败')
			})
		},

		// 获取Token
		getToken(user_name, pwd) {
			return new Promise((resolve) => {
				const getPkeyUrl = `${this.api}index.php?ctl=tool&act=get_pkey`
				const httpRequest = new XMLHttpRequest()

				httpRequest.onreadystatechange = () => {
					if (httpRequest.readyState === 4) {
						if (httpRequest.status === 200) {
							try {
								const json = JSON.parse(httpRequest.responseText)
								if (json.status) {
									this.getTokenWithPkey(user_name, json.data).then(resolve)
								} else {
									this.addLog('error', `获取PKey失败: ${json.msg}`)
									resolve(null)
								}
							} catch (e) {
								this.addLog('error', '解析PKey响应失败')
								resolve(null)
							}
						} else {
							this.addLog('error', '获取PKey接口异常')
							resolve(null)
						}
					}
				}

				httpRequest.open('POST', getPkeyUrl, true)
				httpRequest.send(JSON.stringify({ user_name, pwd }))
			})
		},

		getTokenWithPkey(user_name, pkey) {
			return new Promise((resolve) => {
				const getTokenUrl = `${this.api}index.php?ctl=tool&act=get_token`
				const httpRequest = new XMLHttpRequest()

				httpRequest.onreadystatechange = () => {
					if (httpRequest.readyState === 4) {
						if (httpRequest.status === 200) {
							try {
								const json = JSON.parse(httpRequest.responseText)
								if (json.status) {
									resolve(json.token)
								} else {
									this.addLog('error', `获取Token失败: ${json.msg}`)
									resolve(null)
								}
							} catch (e) {
								this.addLog('error', '解析Token响应失败')
								resolve(null)
							}
						} else {
							this.addLog('error', '获取Token接口异常')
							resolve(null)
						}
					}
				}

				httpRequest.open('POST', getTokenUrl, true)
				httpRequest.send(JSON.stringify({ user_name, pkey }))
			})
		},

		// 处理消息
		handleMessage(data) {
			try {
				const json_obj = JSON.parse(data)
				this.addLog('info', `收到消息: ${json_obj.cmd}`)

				switch (json_obj.cmd) {
					case 'ma_login':
						this.handleLoginResponse(json_obj)
						break
					case 'ma_open_rtsp':
						this.handleRtspResponse(json_obj)
						break
					case 'ma_webrtc_call':
						this.handleWebrtcCall(json_obj)
						break
					case 'server_push_ca_sip_sos':
						this.handleSosAlert(json_obj)
						break
					case 'ma_open_group_sip_video_call':
						this.handleGroupCall(json_obj)
						break
					default:
						this.addLog('warning', `未知消息类型: ${json_obj.cmd}`)
				}
			} catch (e) {
				this.addLog('error', `消息解析失败: ${e.message}`)
			}
		},

		// 处理登录响应
		handleLoginResponse(json_obj) {
			if (json_obj.status) {
				this.addLog('success', '登录成功')
				this.adminId = json_obj.admin_info.admin_id
				this.addLog('info', `管理员ID: ${this.adminId}`)
				this.callButton()
				// this.regUserAgent(json_obj.admin_info)
			} else {
				this.addLog('error', `登录失败: ${json_obj.msg}`)
				this.showError('登录失败')
			}
		},


		// 发起通话按钮
		callButton() {
			if (!this.isGroupCall) {
				const sip_msg = {
					act: "ma_webrtc_call",
					device_id: this.deviceId,
					type: 1
				}
				const rtmp_msg = {
					act: 'ma_open_rtsp',
					device_id: this.deviceId
				}

				this.ws.send(JSON.stringify(sip_msg))

				this.startRtmpTimer(rtmp_msg)
			}
		},

		// 启动RTMP拉流定时器
		startRtmpTimer(rtmp_msg) {
			this.stopRtmpTimer()
			this.rtmpTimer = setInterval(() => {
				if (this.ws && this.ws.readyState === WebSocket.OPEN) {
					this.ws.send(JSON.stringify(rtmp_msg))
				}
			}, 3000)
		},

		stopRtmpTimer() {
			if (this.rtmpTimer) {
				clearInterval(this.rtmpTimer)
				this.rtmpTimer = null
			}
		},


		// 处理RTSP响应
		handleRtspResponse(json_obj) {
			if (json_obj.status && json_obj.webrtc_url) {
				this.addLog('info', '收到RTSP流地址')
				this.stopRtmpTimer()
				this.startZLMPlayer(json_obj.webrtc_url, true)
			} else {
				this.addLog('warning', 'RTSP请求失败，设备可能离线')
			}
		},

		// 处理WebRTC通话
		handleWebrtcCall(json_obj) {
			if (json_obj.status && json_obj.members && json_obj.members.length > 0) {
				this.addLog('info', '收到WebRTC通话邀请')
				this.stopRtmpTimer()

				for (let z = 0; z < json_obj.members.length; z++) {
					// 设备推流（web端拉流）
					if (json_obj.members[z].is_caps === 1) {
						this.addLog('info', `设备推流地址: ${json_obj.members[z].rtc_url[0]}`)
						this.startZLMPlayer(json_obj.members[z].rtc_url[0], true)
					} else {
						// web端推流
						this.addLog('info', `web端推流地址: ${json_obj.members[z].rtc_url[1]}`)
						this.startZLMPlayer(json_obj.members[z].rtc_url[1], false)
					}
				}
			} else {
				this.addLog('warning', 'WebRTC请求失败，请检查设备是否在线')
			}
		},

		// 启动ZLM播放器
		startZLMPlayer(rtcUrl, recvOnly) {
			try {
				this.stopRtmpTimer()

				if (recvOnly) {
					// 拉流模式
					if (this.player) {
						this.player.close()
						this.player = null
					}

					this.player = new ZLMRTCClient.Endpoint({
						element: document.getElementById('remoteVideo'),
						debug: true,
						zlmsdpUrl: rtcUrl,
						simulcast: true,
						useCamera: true,
						audioEnable: true,
						videoEnable: true,
						recvOnly: true,
						resolution: {
							w: 1260,
							h: 710
						}
					})
					this.loading = false
					this.isPlaying = true
					this.addLog('success', '视频开始播放')
				} else {
					// 推流模式
					if (this.player1) {
						this.player1.close()
						this.player1 = null
					}

					this.player1 = new ZLMRTCClient.Endpoint({
						element: document.getElementById('localVideo'),
						zlmsdpUrl: rtcUrl,
						debug: true,
						simulcast: false,
						useCamera: true,
						audioEnable: true,
						videoEnable: false,
						recvOnly: false,
						resolution: {
							w: 640,
							h: 480
						}
					})

					this.addLog('success', '本地推流已启动')
				}
			} catch (e) {
				this.addLog('error', `播放器初始化失败: ${e.message}`)
				this.showError('视频播放失败')
			}
		},

		// 处理SOS报警
		handleSosAlert(json_obj) {
			this.addLog('warning', `收到${json_obj.ca_info.user_name}的SOS报警`)
			document.getElementById('guaButton')?.removeAttribute('disabled')

			const rtmp_msg = {
				act: 'ma_open_rtsp',
				device_id: json_obj.ca_info.device_id
			}

			this.startRtmpTimer(rtmp_msg)
		},

		// 处理群组通话
		handleGroupCall(json_obj) {
			this.addLog('info', '收到群组通话邀请')
			if (json_obj.status && json_obj.members && json_obj.members.length > 0) {
				this.isGroupCall = true
				this.stopRtmpTimer()

				for (let z = 0; z < json_obj.members.length; z++) {
					if (json_obj.members[z].is_caps === 1) {
						this.addLog('info', `群组设备推流地址: ${json_obj.members[z].rtc_url[0]}`)
						this.startZLMPlayer(json_obj.members[z].rtc_url[0], true)
					}
				}
			}
		},

		// 获取房间列表
		getRoomList() {
			if (!this.adminId || !this.token) {
				this.addLog('error', '无法获取房间列表：缺少管理员ID或Token')
				return
			}

			const apiUrl = `${this.api}index.php?ctl=room&act=get_room_list&admin_id=${this.adminId}&token=${this.token}`
			this.addLog('info', `获取房间列表: ${apiUrl}`)

			fetch(apiUrl)
				.then(response => response.json())
				.then(data => {
					this.addLog('info', `房间列表获取成功: ${JSON.stringify(data)}`)
				})
				.catch(error => {
					this.addLog('error', `获取房间列表失败: ${error.message}`)
				})
		},

		// 发起群组通话
		startGroupCall(roomId) {
			if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
				this.addLog('error', 'WebSocket未连接')
				return
			}

			const sipMsg = {
				act: 'ma_webrtc_call',
				room_id: roomId,
				type: 1
			}

			this.addLog('info', `发起群组通话: room_id=${roomId}`)
			this.ws.send(JSON.stringify(sipMsg))
		},

		// 切换静音
		toggleMute() {
			if (!this.sipsession) return

			this.isMuted = !this.isMuted
			this.sipsession.mute('audio', this.isMuted)
			this.addLog('info', this.isMuted ? '已静音' : '已取消静音')
		},

		// 切换视频
		toggleVideo() {
			if (!this.sipsession) return

			this.isVideoOff = !this.isVideoOff
			this.sipsession.mute('video', this.isVideoOff)
			this.addLog('info', this.isVideoOff ? '已关闭摄像头' : '已开启摄像头')
		},

		// 刷新视频流
		// refreshStream() {
		// 	if (this.loading) return

		// 	this.addLog('info', '正在刷新视频流...')
		// 	this.loading = true
		// 	this.isPlaying = false

		// 	if (this.player) {
		// 		this.player.close()
		// 		this.player = null
		// 	}

		// 	const rtmp_msg = {
		// 		act: 'ma_open_rtsp',
		// 		device_id: this.deviceId
		// 	}

		// 	this.startRtmpTimer(rtmp_msg)

		// 	setTimeout(() => {
		// 		if (this.loading) {
		// 			this.showError('刷新超时，请检查网络连接')
		// 			this.loading = false
		// 		}
		// 	}, 80000)
		// },

		// 切换视频质量
		changeVideoQuality() {
			const qualityMap = {
				high: '高清',
				medium: '标清',
				low: '流畅'
			}
			this.videoQuality = qualityMap[this.selectedQuality]
			this.addLog('info', `视频质量已切换为: ${this.videoQuality}`)

			// 实际项目中这里会发送指令给设备调整质量
			this.$message({
				message: `视频质量已调整为${this.videoQuality}`,
				type: 'info',
				duration: 2000
			})
		},

		// 切换全屏
		toggleFullscreen() {
			const container = document.querySelector('.video-call-container')
			if (!container) return

			if (!document.fullscreenElement) {
				container.requestFullscreen().catch(e => {
					this.addLog('error', `全屏切换失败: ${e.message}`)
				})
			} else {
				document.exitFullscreen().catch(e => {
					this.addLog('error', `退出全屏失败: ${e.message}`)
				})
			}
		},

		// 断开连接
		handleDisconnect() {
			this.loading = false
			this.isConnecting = false
			this.isConnected = false

			this.$confirm('确定要结束通话并关闭页面吗？', '确认关闭', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.addLog('info', '正在断开连接...')
				// 停止RTSP
				const stopMsg = {
					act: 'ma_stop_rtsp',
					device_id: this.deviceId
				}
				this.addLog('info', '20秒后自动断开连接...')

				if (this.ws && this.ws.readyState === WebSocket.OPEN) {
					this.addLog('info', '4')
					this.ws.send(JSON.stringify(stopMsg))
					window.close()
				}
				this.cleanup()
				this.wsInitiativeClose = true
				this.ws?.close()

				window.opener = null
				window.open('', '_self')

			}).catch(() => {
				this.addLog('info', '已取消关闭操作')
				window.close();
			})
		},

		// 处理页面关闭前
		handleBeforeUnload() {
			this.cleanup()
			this.wsInitiativeClose = true
			this.ws?.close()
		},

		// 清理资源
		cleanup() {
			this.stopHeartbeat()
			this.stopRtmpTimer()
			this.stopCallDuration()

			if (this.player) {
				this.player.close()
				this.player = null
			}

			if (this.player1) {
				this.player1.close()
				this.player1 = null
			}

			if (this.userAgent) {
				this.userAgent.disconnect()
				this.userAgent = null
			}

			this.cleanupMedia()
		},

		// 清理媒体
		cleanupMedia() {
			const remoteVideo = document.getElementById('remoteVideo')
			if (remoteVideo) {
				remoteVideo.srcObject = null
				remoteVideo.load()
			}

			const localVideo = document.getElementById('localVideo')
			if (localVideo) {
				localVideo.srcObject = null
				localVideo.load()
			}

			this.isPlaying = false
			this.isConnected = false
		},

		// 重新连接
		handleReconnect() {
			if (this.reconnectCount >= this.maxReconnectAttempts) {
				this.addLog('error', '已达到最大重连次数')
				this.showError('网络连接已断开，请刷新页面')
				return
			}

			this.reconnectCount++
			this.addLog('info', `第${this.reconnectCount}次尝试重新连接...`)

			this.reconnectTimer = setTimeout(() => {
				this.initWebSocket()
			}, 5000 * this.reconnectCount)
		},

		// 开始计时
		startCallDuration() {
			this.stopCallDuration()
			this.callDuration = 0
			this.callDurationTimer = setInterval(() => {
				this.callDuration++
			}, 1000)
		},

		stopCallDuration() {
			if (this.callDurationTimer) {
				clearInterval(this.callDurationTimer)
				this.callDurationTimer = null
			}
		},

		// 视频加载完成
		onVideoLoaded() {
			this.addLog('info', '视频元数据加载完成')
		},

		// 视频错误处理
		onVideoError(e) {
			this.addLog('error', `视频错误: ${e.target.error?.message || '未知错误'}`)
			this.showError('视频加载失败')
		}
	}
}
</script>

<style scoped>
/* 清新简约风格主题变量 */
:root {
	--primary: #4f46e5;
	--primary-light: #6366f1;
	--primary-soft: rgba(99, 102, 241, 0.1);
	--success: #10b981;
	--warning: #f59e0b;
	--danger: #ef4444;
	--bg-primary: #f8fafc;
	--bg-secondary: #ffffff;
	--bg-tertiary: #f1f5f9;
	--text-primary: #1e293b;
	--text-secondary: #64748b;
	--text-muted: #94a3b8;
	--border: #e2e8f0;
	--shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
	--shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
	--shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	--shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	--shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.video-call-container {
	width: 98vw;
	height: 98vh;
	display: flex;
	flex-direction: column;
	background: var(--bg-primary);
	position: relative;
	overflow: hidden;
}

.header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 32px;
	background: var(--bg-secondary);
	border-bottom: 1px solid var(--border);
	color: var(--text-primary);
	flex-shrink: 0;
	z-index: 10;
	box-shadow: var(--shadow-sm);
}

.header-left {
	display: flex;
	align-items: center;
	gap: 16px;
}

.status-badge .el-badge__content {
	font-size: 12px;
	padding: 6px 14px;
	border-radius: 9999px;
	font-weight: 600;
	border: none;
}

.status-badge .el-badge__content.is-success {
	background: var(--success);
	color: #fff;
}

.status-badge .el-badge__content.is-warning {
	background: var(--warning);
	color: #fff;
}

.status-badge .el-badge__content.is-danger {
	background: var(--danger);
	color: #fff;
}

.status-badge .el-badge__content.is-info {
	background: var(--primary);
	color: #fff;
}

.device-info {
	font-size: 15px;
	font-weight: 600;
	color: var(--text-primary);
	letter-spacing: -0.025em;
}

.connection-time {
	font-size: 14px;
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
	background: var(--bg-tertiary);
	color: var(--text-secondary);
	padding: 8px 16px;
	border-radius: 8px;
	font-weight: 500;
	letter-spacing: 0.025em;
	border: 1px solid var(--border);
}

.video-wrapper {
	flex: 1;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background: var(--bg-primary);
	padding: 24px;
	z-index: 1;
}

.main-video-area {
	position: relative;
	width: 100%;
	height: 100%;
	max-width: 1220px;
	max-height: 720px;
	border-radius: 20px;
	overflow: hidden;
	background: #000;
	box-shadow: var(--shadow-xl);
}

.remote-video {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background: #000;
}

.video-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(15, 23, 42, 0.9);
	z-index: 5;
	backdrop-filter: blur(8px);
}

.overlay-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	color: var(--text-secondary);
	font-size: 16px;
	text-align: center;
}

.overlay-content .el-icon-video-camera {
	font-size: 56px;
	color: var(--primary);
	animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

	0%,
	100% {
		opacity: 1;
		transform: scale(1);
	}

	50% {
		opacity: 0.7;
		transform: scale(1.05);
	}
}

.video-controls-overlay {
	position: absolute;
	top: 20px;
	right: 20px;
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(12px);
	padding: 10px 18px;
	border-radius: 12px;
	color: var(--text-primary);
	font-size: 13px;
	z-index: 5;
	box-shadow: var(--shadow-md);
	border: 1px solid var(--border);
	font-weight: 500;
}

.video-quality {
	display: flex;
	align-items: center;
	gap: 8px;
}

.video-quality::before {
	content: '';
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: var(--success);
}

.local-preview {
	position: absolute;
	bottom: 120px;
	right: 32px;
	width: 200px;
	height: 130px;
	border-radius: 16px;
	overflow: hidden;
	background: var(--bg-secondary);
	box-shadow: var(--shadow-lg);
	z-index: 10;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	border: 3px solid #fff;
}

.local-preview:hover {
	transform: scale(1.03) translateY(-4px);
	box-shadow: var(--shadow-xl);
}

.local-video {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.local-label {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.7));
	color: #fff;
	font-size: 12px;
	font-weight: 500;
	padding: 16px 8px 8px;
	text-align: center;
}

.control-panel {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 32px;
	padding: 20px 32px;
	background: var(--bg-secondary);
	border-top: 1px solid var(--border);
	flex-shrink: 0;
	z-index: 10;
	box-shadow: var(--shadow-sm);
}

.control-group {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
}

.control-group .el-button {
	width: 56px;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 16px;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	border: 1px solid var(--border);
	background: var(--bg-secondary);
	color: var(--text-secondary);
	font-size: 20px;
	box-shadow: var(--shadow-sm);
}

/* .control-group .el-button:hover:not(:disabled) {
	transform: translateY(-2px);
	background: var(--bg-tertiary);
	border-color: var(--primary-light);
	color: var(--primary);
	box-shadow: var(--shadow-md);
} */

/* .control-group .el-button:active:not(:disabled) {
	transform: translateY(0);
	box-shadow: var(--shadow-sm);
}

.control-group .el-button:disabled {
	opacity: 0.4;
	cursor: not-allowed;
	background: var(--bg-tertiary);
} */

.control-group .el-button.is-primary {
	background: var(--primary-soft);
	border-color: var(--primary);
	color: var(--primary);
}

.control-group .el-button.is-warning {
	background: rgba(245, 158, 11, 0.1);
	border-color: var(--warning);
	color: var(--warning);
}

.control-label {
	font-size: 12px;
	color: var(--text-muted);
	font-weight: 500;
	letter-spacing: 0.025em;
}

.control-group:hover .control-label {
	color: var(--text-secondary);
}

.quality-control {
	flex-direction: row;
	gap: 12px;
	align-items: center;
}

.quality-select {
	width: 110px;
}

.quality-select .el-input__inner {
	background: var(--bg-secondary);
	border: 1px solid var(--border);
	color: var(--text-primary);
	font-size: 13px;
	font-weight: 500;
	border-radius: 10px;
	padding: 8px 12px;
	transition: all 0.2s ease;
}

.quality-select .el-input__inner:hover,
.quality-select .el-input__inner:focus {
	border-color: var(--primary-light);
	box-shadow: 0 0 0 3px var(--primary-soft);
}

.quality-select .el-select-dropdown {
	background: var(--bg-secondary);
	border: 1px solid var(--border);
	border-radius: 12px;
	box-shadow: var(--shadow-lg);
}

.quality-select .el-select-dropdown__item {
	color: var(--text-primary);
	padding: 10px 16px;
	font-weight: 500;
}

.quality-select .el-select-dropdown__item:hover {
	background: var(--bg-tertiary);
	color: var(--primary);
}

.disconnect-group .el-button {
	/* background: var(--danger); */
	/* border-color: var(--danger); */
	position: relative;
}

.disconnect-group .el-button::after {
	content: '';
	position: absolute;
	top: 50%;
	left: 50%;
	width: 60%;
	height: 3px;
	/* background: #fff; */
	transform: translate(-50%, -50%) rotate(-45deg);
	border-radius: 2px;
}

.disconnect-group .el-button:hover:not(:disabled) {
	background: #dc2626;
	border-color: #dc2626;
	transform: translateY(-2px);
	box-shadow: 0 4px 16px rgba(239, 68, 68, 0.5);
	color: #fff;
}

.disconnect-group:hover .control-label {
	color: var(--danger);
}

.log-panel {
	position: absolute;
	bottom: 150px;
	left: 0px;
	width: 300px;
	max-height: 360px;
	background: var(--bg-secondary);
	border: 1px solid var(--border);
	border-radius: 16px;
	overflow: hidden;
	z-index: 20;
	transition: all 0.3s ease;
	box-shadow: var(--shadow-lg);
}

.log-panel:hover {
	box-shadow: var(--shadow-xl);
}

.log-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 14px 18px;
	background: var(--bg-tertiary);
	cursor: pointer;
	border-bottom: 1px solid var(--border);
	transition: background 0.2s ease;
}

.log-header:hover {
	background: var(--border);
}

.log-title {
	font-size: 13px;
	color: var(--text-primary);
	font-weight: 600;
	letter-spacing: -0.025em;
	display: flex;
	align-items: center;
	gap: 8px;
}

.log-title::before {
	content: '';
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: var(--success);
}

.log-content {
	padding: 12px 16px;
	max-height: 260px;
	overflow-y: auto;
}

.log-content::-webkit-scrollbar {
	width: 6px;
}

.log-content::-webkit-scrollbar-track {
	background: var(--bg-tertiary);
	border-radius: 3px;
}

.log-content::-webkit-scrollbar-thumb {
	background: var(--border);
	border-radius: 3px;
}

.log-content::-webkit-scrollbar-thumb:hover {
	background: var(--text-muted);
}

.log-item {
	display: flex;
	gap: 12px;
	font-size: 13px;
	padding: 8px 0;
	border-bottom: 1px solid var(--border);
	transition: background 0.15s ease;
}

.log-item:hover {
	background: var(--bg-tertiary);
	margin: 0 -16px;
	padding-left: 16px;
	padding-right: 16px;
}

.log-item:last-child {
	border-bottom: none;
}

.log-time {
	color: var(--text-muted);
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
	font-size: 11px;
	min-width: 52px;
	font-weight: 500;
}

.log-message {
	color: var(--text-secondary);
	line-height: 1.5;
	font-weight: 500;
}

.log-success .log-message {
	color: var(--success);
}

.log-error .log-message {
	color: var(--danger);
}

.log-warning .log-message {
	color: var(--warning);
}

.log-info .log-message {
	color: var(--primary);
}

@media (max-width: 768px) {
	.header-bar {
		padding: 14px 20px;
	}

	.device-info {
		font-size: 14px;
	}

	.connection-time {
		font-size: 13px;
		padding: 6px 12px;
	}

	.video-wrapper {
		padding: 16px;
	}

	.main-video-area {
		border-radius: 16px;
	}

	.control-panel {
		gap: 20px;
		padding: 16px 20px;
	}

	.control-group .el-button {
		width: 48px;
		height: 48px;
		font-size: 18px;
		border-radius: 12px;
	}

	.control-label {
		font-size: 11px;
	}

	.local-preview {
		width: 150px;
		height: 100px;
		bottom: 100px;
		right: 16px;
		border-radius: 12px;
	}

	.log-panel {
		width: calc(100% - 32px);
		left: 16px;
		bottom: 100px;
	}

	.quality-select {
		width: 90px;
	}
}

@media (max-width: 480px) {
	.header-bar {
		flex-direction: column;
		gap: 10px;
		text-align: center;
		padding: 12px 16px;
	}

	.control-panel {
		gap: 12px;
		padding: 14px 12px;
	}

	.control-group .el-button {
		width: 44px;
		height: 44px;
		font-size: 16px;
		border-radius: 10px;
	}

	.control-label {
		font-size: 10px;
	}

	.local-preview {
		width: 120px;
		height: 80px;
		bottom: 90px;
		right: 12px;
	}

	.quality-select {
		width: 75px;
	}

	.log-panel {
		bottom: 90px;
		left: 12px;
		width: calc(100% - 24px);
	}
}
</style>